import {
  ALL_TIME_GREATS_CATEGORIES,
  ALL_TIME_GREATS_DEFAULT,
  ALL_TIME_GREATS_STATS,
  defaultStatForCategory,
  getAllTimeGreatsStat,
} from "../constants/allTimeGreats";

const isCategory = (value) =>
  ALL_TIME_GREATS_CATEGORIES.some((category) => category.value === value);

export const parseAllTimeGreatsSearch = (searchParams) => {
  const categoryParam = searchParams?.get?.("category");
  const statParam = searchParams?.get?.("stat");
  const knownStat = ALL_TIME_GREATS_STATS[statParam];

  if (knownStat) {
    return { category: knownStat.category, stat: knownStat.key };
  }

  const category = isCategory(categoryParam)
    ? categoryParam
    : ALL_TIME_GREATS_DEFAULT.category;

  return { category, stat: defaultStatForCategory(category) };
};

export const serializeAllTimeGreatsSearch = ({ category, stat }) => {
  const resolved = parseAllTimeGreatsSearch({
    get: (key) => (key === "category" ? category : key === "stat" ? stat : null),
  });
  const params = new URLSearchParams();
  params.set("category", resolved.category);
  params.set("stat", resolved.stat);
  return params;
};

export { filterRowsByPlayerName as filterLeaderboardRowsByName } from "./filterRowsByPlayerName";

export const splitGreatsRows = (
  rows = [],
  { page = 0, searchTerm = "" } = {}
) => {
  const searching = Boolean(searchTerm.trim());
  const showFeatured = page === 0 && !searching && rows.length >= 3;
  if (!showFeatured) {
    return { featured: [], list: rows, showFeatured: false };
  }
  return {
    featured: rows.slice(0, 3),
    list: rows.slice(3),
    showFeatured: true,
  };
};

export const getGreatsQualifier = (statKey) =>
  getAllTimeGreatsStat(statKey).qualifier || null;

export const buildGreatsGalleryItems = (featured = [], list = []) => {
  const seen = new Set();
  const items = [];
  [...featured, ...list].forEach((row) => {
    const playerId = row?.playerId;
    if (!playerId || seen.has(playerId)) return;
    seen.add(playerId);
    items.push(row);
  });
  return items;
};

export const clampGalleryIndex = (index, length) => {
  if (!length || length <= 0) return 0;
  if (index < 0) return 0;
  if (index >= length) return length - 1;
  return index;
};

export const stepGalleryIndex = (index, delta, length) =>
  clampGalleryIndex(index + delta, length);

export const findGalleryIndex = (items = [], playerId) => {
  if (!playerId) return -1;
  return items.findIndex((item) => item?.playerId === playerId);
};

export const reconcileGalleryIndex = (items = [], playerId) => {
  const index = findGalleryIndex(items, playerId);
  return index < 0 ? null : index;
};

export const galleryStepFromKey = (key) => {
  if (key === "ArrowLeft") return -1;
  if (key === "ArrowRight") return 1;
  return null;
};
